import React from "react";
import { Box } from "@mui/material";
import Header from "components/Header";
import BreakdownChart from "components/BreakdownChart";

const Breakdown = () => {
  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="RÉPARTITION"
        subtitle="Répartition des ventes par compteurs"
      />
      <Box mt="20px" height="70vh">
        <BreakdownChart />
      </Box>
    </Box>
  );
};

export default Breakdown;
